import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TranslationService from "../../../../Services/Translation/TranslationService";
import AutoTranslate from "../../../../Components/AutoTranslate";

const Step4 = ({ stepLabels = [], onPrev = () => {}, onSubmit = () => {}, formData = {} }) => {
  const language = useSelector((state) => state.localStorage.language);
  const getValueClass = (value) => {
    return value && value !== "" ? "valid" : "invalid";
  };
  const [wording, setWording] = useState({
    placeholder: "상세한 답변을 입력해주세요...",
  });

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    const _placeholder = await TranslationService.translateText(wording.placeholder, language.lang);
    setWording({ ...wording, placeholder: _placeholder });
  };

  return (
    <div className='flex-column-center-center gap-5 w-100'>
      <div className='step-card'>
        <div className='step-card-header'>
          <h2 className='step-form-title' style={{ color: "white", margin: 0 }}>
            <AutoTranslate targetLanguage={language.lang}>{stepLabels[4]}</AutoTranslate>
          </h2>
        </div>
        <div className='step-card-body'>
          <div>
            <h5 style={{ marginBottom: "1.5rem", color: "#2c3e50" }}>입력된 정보 확인</h5>
            <div className='row'>
              <div className='col-md-6'>
                <div className='step-info-row'>
                  <span className='step-info-label'>작업 예정일:</span>
                  <span className={`step-info-value ${getValueClass(formData.jobDate)}`}>{formData.jobDate || "미입력"}</span>
                </div>
                <div className='step-info-row'>
                  <span className='step-info-label'>비상연락처:</span>
                  <span className={`step-info-value ${getValueClass(formData.emergencyPhone)}`}>{formData.emergencyPhone || "미입력"}</span>
                </div>
                <div className='step-info-row'>
                  <span className='step-info-label'>최고 혈압:</span>
                  <span className={`step-info-value ${getValueClass(formData.highBloodPressure)}`}>{formData.highBloodPressure || "미입력"}</span>
                </div>
                <div className='step-info-row'>
                  <span className='step-info-label'>최저 혈압:</span>
                  <span className={`step-info-value ${getValueClass(formData.lowBloodPressure)}`}>{formData.lowBloodPressure || "미입력"}</span>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='step-info-row'>
                  <span className='step-info-label'>경력:</span>
                  <span className={`step-info-value ${getValueClass(formData.workExperience)}`}>{formData.workExperience === "0" ? "신입" : `${formData.workExperience}년`}</span>
                </div>
                <div className='step-info-row'>
                  <span className='step-info-label'>흡연:</span>
                  <span className={`step-info-value ${getValueClass(formData.smoking)}`}>{formData.smoking === "0" ? "비흡연" : "흡연"}</span>
                </div>
                <div className='step-info-row'>
                  <span className='step-info-label'>음주:</span>
                  <span className={`step-info-value ${getValueClass(formData.drinking)}`}>{formData.drinking === "0" ? "음주하지 않음" : "음주함"}</span>
                </div>
              </div>
            </div>
          </div>
          <div className='step-button-group'>
            <button className='step-button step-button-secondary' onClick={onPrev}>
              <AutoTranslate targetLanguage={language.lang}>이전</AutoTranslate>
            </button>
            <button className='step-button step-button-success' onClick={onSubmit}>
              <AutoTranslate targetLanguage={language.lang}>제출하기</AutoTranslate>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4;
